import { validateEmailRegex, validatePhone } from '@/utils/validates';
import * as yup from 'yup';

export const occupationAreaSchema = yup.object().shape({
  categoriesLength: yup
    .number()
    .min(1, 'Selecione ao menos uma categoria para prosseguir!'),
  operationTypesLength: yup
    .number()
    .min(1, 'Selecione ao menos uma área de atuação para prosseguir!'),
});

export const companyContactsSchema = yup.object().shape({
  shipping_locations: yup
    .array()
    .test(
      'isArrayEmpty',
      'Selecione um local de entrega para prosseguir!',
      arr => !!(arr && arr.length > 0)
    ),
  email: yup
    .string()
    .required('Preencha todos os campos de texto para prosseguir!')
    .matches(validateEmailRegex, 'Digite um e-mail válido'),
  phone: yup
    .string()
    .required('Preencha todos os campos de texto para prosseguir!')
    .test(
      'is-valid-number',
      'Digite um telefone válido',
      async phone => await validatePhone(phone || Array(13).fill('1').join(''))
    ),
});
